// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login[data-v-26084dc2] {\n  width: 100%;\n  height: 40px !important;\n  color: #fff;\n}\n.login-body[data-v-26084dc2],\n.login-card[data-v-26084dc2],\n.v-application--wrap[data-v-26084dc2] {\n  border-radius: 50px;\n}\n.v-application .mb-6[data-v-26084dc2] {\n  margin-bottom: 0px !important;\n}\n@media only screen and (max-width: 600px) {\n.v-btn[data-v-26084dc2] {\n    font-size: 0.75em;\n}\n}\n", ""]);
// Exports
module.exports = exports;
